import {http} from '../http'
import * as coreAuth from '../../coreApi/auth'

import {APIResponse} from '../types'
import {handleError} from '../handleError'

type ResolvedReturn = APIResponse<null>

export interface Refresh {
  (): Promise<ResolvedReturn>
}

const ERROR_PATH = 'api.auth.refresh()'
const GENERIC_ERROR = 'general'

/**
 * Rotates the legacy admin session (AB#24880).
 *
 * Like every other domain-layer call this never throws — it resolves a
 * `failure` instead. That matters more than usual here: the 401 recovery in
 * `http.ts` calls this from inside the axios response interceptor, and a
 * throw there would re-enter the very error path it is trying to recover.
 */
export const refresh: Refresh = async () => {
  let resolvedReturn: ResolvedReturn

  try {
    // Success is the HTTP status, not a body field. `/v1/auth/refresh` answers
    // `{"Token":""}` on success — the rotated TokenID rides a Secure/HttpOnly
    // cookie and the body is deliberately emptied server-side, so there is
    // nothing in it to inspect. The shared axios instance leaves
    // `validateStatus` at the default, so a non-2xx rejects and lands in the
    // catch below; reaching this line at all means the session slid.
    //
    // Do not reintroduce a body check here. This previously required
    // `data.Status === 'Success'`, a field the auth contract does not define,
    // which turned every successful refresh into a failure and handed control
    // to the Auth0 re-exchange fallback — the full-page redirect that kills an
    // in-flight photo upload (AB#24880).
    await coreAuth.refresh(http)

    resolvedReturn = {
      result: 'success',
      data: null,
    }
  } catch (e) {
    resolvedReturn = handleError(ERROR_PATH, GENERIC_ERROR, e)
  }
  return Promise.resolve(resolvedReturn)
}
